export default "__VITE_ASSET__yvGufxov__"